var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.outTime
        ? _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.playVideo()
                },
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-video-camera",
                staticStyle: { "font-size": "40px!important" },
              }),
            ]
          )
        : _vm._e(),
      _vm.outTime
        ? _c("div", [
            _c("i", { staticClass: "el-icon-video-play shipin-i" }),
            _c("p"),
            _c("i", { staticClass: "el-icon-time" }, [_vm._v(" 该视频已过期")]),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.mainLoading,
              expression: "mainLoading",
            },
          ],
          attrs: {
            title: "视频播放",
            visible: _vm.dialogVideo,
            width: "40%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVideo = $event
            },
          },
        },
        [
          _vm.playerOptions.sources[0].src
            ? _c("video-player", {
                ref: "videoPlayer",
                staticClass: "video-player vjs-custom-skin",
                attrs: { options: _vm.playerOptions },
                on: {
                  play: function ($event) {
                    return _vm.onPlayerPlay($event)
                  },
                  pause: function ($event) {
                    return _vm.onPlayerPause($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }